module.exports = __webpack_public_path__ + "img/aimPoint5.e9cfa380.png";